import { Component } from '@angular/core';

/**
 * Casca da tela master de "Solicitacoes de Contador".
 *
 * Renderiza um cabecalho de pagina e o subcomponente
 * `app-aprovacao-solicitacoes` (tabela lazy + acoes de aprovar/recusar).
 *
 * Repasse de comissoes e historico de pagamentos ficam em telas proprias
 * (`/contador/comissoes` e `/contador/comissoes/historico`).
 *
 * Acesso restrito via `masterAccessGuard` na rota `/contador/aprovacao`.
 */
@Component({
  selector: 'app-aprovacao-contador',
  templateUrl: './aprovacao-contador.component.html',
  styleUrls: ['./aprovacao-contador.component.scss'],
})
export class AprovacaoContadorComponent {}
